import { Spin, Row, Col, Input, Tabs } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Back from "../../../assets/images/backIcon.svg";

const { TabPane } = Tabs;

const EstimatesView = ({
  colorVariable,
  isEstimatesFlag,
  setIsEstimatesFlag,
  activeEstimatesTab,
  setActiveEstimatesTab,
  searchEstimatesInput,
  setSearchEstimatesInput,
  loadingEstimates,
  estimatesData,
  expandedEstimatesRowKey,
  setExpandedEstimatesRowKey,
  fetchEstimates,
  handleRetrieveEstimate,
}) => {
  const getStatusForEstimatesTab = (tab) => {
    switch (tab) {
      case "pending":
        return "PE";
      case "processed":
        return "CO";
      case "cancelled":
        return "CL";
      default:
        return "PE";
    }
  };

  const getStatusConfig = (status) => {
    switch (status) {
      case "pending":
        return {
          code: "PE",
          label: "Pending",
          bg: "#fff4e6",
          color: "#fa8c16",
          empty: "No pending estimates found",
        };
      case "processed":
        return {
          code: "CO",
          label: "Completed",
          bg: "#e6f7ff",
          color: "#1890ff",
          empty: "No processed estimates found",
        };
      case "cancelled":
        return {
          code: "CL",
          label: "Cancelled",
          bg: "#fff1f0",
          color: "#ff4d4f",
          empty: "No cancelled estimates found",
        };
      default:
        return {};
    }
  };

  const renderEstimateList = (status) => {
    const config = getStatusConfig(status);

    return (
      <Spin spinning={loadingEstimates}>
        {estimatesData?.length === 0 && !loadingEstimates ? (
          <div
            style={{
              textAlign: "center",
              padding: "3rem",
              background: "#fff",
              borderRadius: "12px",
              color: "#929098",
            }}
          >
            {config.empty}
          </div>
        ) : (
          <div>
            {/* HEADER */}
            <Row
              style={{
                background: "#fff",
                padding: "1rem 1.5rem",
                borderRadius: "12px 12px 0 0",
                fontWeight: 600,
                fontSize: "0.9rem",
                color: "#5D5A66",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <Col span={4}>Date</Col>
              <Col span={4}>Document No</Col>
              <Col span={5}>Customer</Col>
              <Col span={3}>Qty</Col>
              <Col span={3}>Total</Col>
              <Col span={4}>Status</Col>
            </Row>

            {estimatesData.map((record) => {
              let parsedJson = {};
              try {
                parsedJson = JSON.parse(record.estimate_json || "{}");
              } catch (err) {
                parsedJson = {};
              }
              return (
                <div key={record.key}>
                  {/* MAIN ROW */}
                  <Row
                    style={{
                      background: "#fff",
                      padding: "1rem 1.5rem",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={() => setExpandedEstimatesRowKey(expandedEstimatesRowKey === record.key ? null : record.key)}
                  >
                    <Col span={4}>
                      {expandedEstimatesRowKey === record.key ? (
                        <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                      ) : (
                        <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                      )}{" "}
                      {dayjs(record.created).format("YYYY-MM-DD HH:mm:ss")}
                    </Col>

                    <Col span={4} style={{ fontWeight: 500 }}>
                      {record.documentno}
                    </Col>

                    <Col span={5}>{parsedJson?.customer?.name || "Walkin Customer"}</Col>
                    <Col span={3}>{parsedJson?.totalQty || 0}</Col>
                    <Col span={3} style={{ fontWeight: 500 }}>
                      {parsedJson?.total || 0}
                    </Col>
                    <Col span={4}>
                      <span
                        style={{
                          padding: "0.25rem 0.75rem",
                          borderRadius: "6px",
                          background: config.bg,
                          color: config.color,
                          fontWeight: 500,
                        }}
                      >
                        {config.label}
                      </span>
                    </Col>
                  </Row>

                  {/* EXPANDED AREA */}
                  {expandedEstimatesRowKey === record.key && (
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "1.5rem",
                      }}
                    >
                      {/* ITEMS */}
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "8px",
                          padding: "1rem",
                        }}
                      >
                        <Row
                          style={{
                            fontWeight: 600,
                            borderBottom: "1px solid #f0f0f0",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <Col span={10}>Description</Col>
                          <Col span={4} style={{ textAlign: "center" }}>
                            Qty
                          </Col>
                          <Col span={5} style={{ textAlign: "right" }}>
                            Unit Price
                          </Col>
                          <Col span={5} style={{ textAlign: "right" }}>
                            Net Total
                          </Col>
                        </Row>

                        {parsedJson?.items?.map((item, index) => (
                          <Row
                            key={index}
                            style={{
                              padding: "0.75rem 0",
                              borderBottom: index < parsedJson?.items.length - 1 ? "1px solid #f5f5f5" : "none",
                            }}
                          >
                            <Col span={10}>{item?.name}</Col>
                            <Col span={4} style={{ textAlign: "center" }}>
                              {item?.weight}
                            </Col>
                            <Col span={5} style={{ textAlign: "right" }}>
                              {item?.realPrice}
                            </Col>
                            <Col span={5} style={{ textAlign: "right" }}>
                              {item?.nettotal}
                            </Col>
                          </Row>
                        ))}
                      </div>

                      {/* SUMMARY */}
                      <Row style={{ marginTop: "1.5rem" }}>
                        <Col span={14}></Col>

                        <Col span={10}>
                          <div
                            style={{
                              background: "#fff",
                              borderRadius: "8px",
                              padding: "1rem",
                            }}
                          >
                            <Row>
                              <Col span={12}>Subtotal</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {parsedJson?.subTotal}
                              </Col>
                            </Row>

                            {parsedJson?.discount > 0 && (
                              <Row>
                                <Col span={12} style={{ color: "#ff4d4f" }}>
                                  Discount
                                </Col>
                                <Col
                                  span={12}
                                  style={{
                                    textAlign: "right",
                                    color: "#ff4d4f",
                                  }}
                                >
                                  - {parsedJson?.discount?.toFixed(2)}
                                </Col>
                              </Row>
                            )}

                            <Row>
                              <Col span={12}>Tax</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {parsedJson?.tax?.toFixed(2)}
                              </Col>
                            </Row>

                            <Row
                              style={{
                                fontWeight: 600,
                                marginTop: "0.5rem",
                                borderTop: "1px solid #f0f0f0",
                                paddingTop: "0.5rem",
                              }}
                            >
                              <Col span={12}>TOTAL</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {parsedJson?.total?.toFixed(2)}
                              </Col>
                            </Row>
                          </div>

                          {/* RETRIEVE BUTTON — ONLY FOR PENDING */}
                          {status === "pending" && (
                            <button
                              onClick={() => handleRetrieveEstimate(record)}
                              style={{
                                width: "100%",
                                marginTop: "1rem",
                                padding: "0.75rem",
                                background: "#1890ff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "8px",
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              Retrieve sale
                            </button>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Spin>
    );
  };

  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      {/* ================= HEADER ================= */}
      <Row style={{ padding: "1.5em 1.5em 0", fontSize: "1vw" }}>
        <Col span={6} style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Back}
            onClick={() => {
              setIsEstimatesFlag(false);
              setExpandedEstimatesRowKey(null);
              setActiveEstimatesTab("pending");
              setSearchEstimatesInput("");
            }}
            style={{ height: "2vw", cursor: "pointer", marginRight: "0.5vw" }}
          />

          <span
            style={{
              fontSize: "1.8em",
              fontWeight: 500,
              color: "#0F0718",
            }}
          >
            Estimates
          </span>
        </Col>

        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder="Search estimates"
            style={{ width: "70%", borderRadius: "5px", border: "none" }}
            onPressEnter={() => {
              const status = getStatusForEstimatesTab(activeEstimatesTab);
              fetchEstimates(status);
            }}
            onChange={(e) => setSearchEstimatesInput(e.target.value)}
            value={searchEstimatesInput}
          />
        </Col>
      </Row>

      <Row style={{ padding: "1em 1.5em" }}>
        <Tabs
          activeKey={activeEstimatesTab}
          onChange={(key) => {
            setActiveEstimatesTab(key);
            setExpandedEstimatesRowKey(null);
            const status = getStatusForEstimatesTab(key);
            fetchEstimates(status);
          }}
          style={{ width: "100%" }}
        >
          <TabPane tab="Pending" key="pending">
            {renderEstimateList("pending")}
          </TabPane>

          <TabPane tab="Processed" key="processed">
            {renderEstimateList("processed")}
          </TabPane>

          <TabPane tab="Cancelled" key="cancelled">
            {renderEstimateList("cancelled")}
          </TabPane>
        </Tabs>
      </Row>
    </div>
  );
};

export default EstimatesView;
